import { types } from "../types";

const DeviceTypeAction = {
    getDeviceTypeList: () => {
        return { type: types.GET_DEVICETYPE };
    },
    getDeviceTypeListSuccess: (deviceTypeList) => {
        return { type: types.GET_DEVICETYPE_SUCCESS, deviceTypeList };
    },
    saveDeviceType: () => {
        return { type: types.SAVE_DEVICETYPE };
    },
    updateDeviceType: () => {
        return { type: types.UPDATE_DEVICETYPE };
    },
    deleteDeviceType: () => {
        return { type: types.DELETE_DEVICETYPE };
    },
    saveDeviceParameters: () => {
        return { type: types.SAVE_DEVICEPARAMETERS };
    },
    deleteDeviceParameters: () => {
        return { type: types.DELETE_DEVICEPARAMETERS };
    },
    getDeviceTypeCM: () => {
        return { type: types.GET_DEVICETYPE_CM };
    },
    getDeviceTypeCMSuccess: () => {
        return { type: types.GET_DEVICETYPE_CM_SUCCESS };
    }
};

export default DeviceTypeAction;